import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/superArena/Index.vue')
const Ranking = () => import('../activity/superArena/Ranking.vue')

export const indexRoute: RouteConfig = {
  path: '/super-arena-activity',
  name: 'super_arena_activity',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '赛季详情',
  },
}

export const rankingRoute: RouteConfig = {
  path: '/super-arena-ranking',
  name: 'super_arena_ranking',
  component: Ranking,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '赛季积分排名',
  },
}

export default [indexRoute, rankingRoute]
